<template>
  <div class="recommended-reading">
    <hr>
    <h2>Recommended Reading</h2>
    <div class="reading-grid">
      <div 
        class="reading-card"
        v-for="paper in recommendedPapers"
        :key="paper.title"
      >
        <div class="reading-card-header">
          <h3>{{ paper.title }}</h3>
          <p class="reading-card-author">{{ paper.author }} &middot; {{ paper.date }}</p>
        </div>
        <p class="reading-card-desc">{{ paper.description }}</p>
        <div class="reading-card-link">
          <a :href="paper.link" target="_blank">Read &rarr;</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RecommendedReading',
  props: {
    recommendedPapers: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
h3 {
  margin-bottom: 0rem;
}

.recommended-reading {
  max-width: 900px;
  margin: 2rem auto;
  padding: 0 1rem;
}
.reading-grid {
  display: grid;
  grid-gap: 1.5rem;
  grid-template-columns: 1fr 1fr;
  margin-top: 1rem;
}
.reading-card {
  border: 1px solid #eee;
  border-radius: 5px;
  padding: 1rem;
  background-color: #fff;
}
.reading-card-header {
  margin-bottom: 0.5rem;
}
.reading-card-author {
  color: #676767; /* COLOR GREY TEXT LABEL */
  font-size: 0.9rem;
  margin: 0.25rem 0 0;
  margin-bottom: 1rem;
}
.reading-card-desc {
  margin: 0.5rem 0;
  line-height: 1.4;
}
.reading-card-link a {
  text-decoration: none;
  color: #007acc;
  font-weight: bold;
}
.reading-card-link a:hover {
  text-decoration: underline;
}
/* Responsive Design */
@media (max-width: 640px) {
  .reading-grid {
    grid-template-columns: 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/modules/RecommendedReading.vue